<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>